import type { InvoiceRow, PaymentRow } from '@hq/api-sdk';
import { formatAmount, formatDisplayTime } from '@hq/utils';
import { Card, Table } from 'antd';
import { invoiceStatusLabel, invoiceTypeLabel, payMethodLabel } from './settle-enums';

/**
 * 对账单详情里的发票 / 付款两块只读表（从 SettleOps 下沉）。
 * 仅做展示，写操作仍由页面上的弹窗承担，避免把状态机塞进展示组件。
 */
export default function SettlePaymentTables({
  invoices,
  payments,
  invoicesLoading,
  paymentsLoading
}: {
  invoices?: InvoiceRow[];
  payments?: PaymentRow[];
  invoicesLoading: boolean;
  paymentsLoading: boolean;
}) {
  return (
    <>
      <Card size="small" title="发票" style={{ marginTop: 16 }}>
        <Table<InvoiceRow>
          rowKey="id"
          size="small"
          pagination={false}
          dataSource={invoices ?? []}
          loading={invoicesLoading}
          locale={{ emptyText: '暂无发票' }}
          columns={[
            { title: '发票号', dataIndex: 'invoiceNo', width: 180 },
            { title: '类型', dataIndex: 'invoiceType', width: 140, render: (value: string | null) => invoiceTypeLabel(value) },
            { title: '价税合计', dataIndex: 'totalAmount', width: 130, align: 'right', render: (value: number) => formatAmount(value) },
            { title: '开票时间', dataIndex: 'invoiceAt', width: 160, render: (value: string | null) => formatDisplayTime(value) },
            { title: '状态', dataIndex: 'status', width: 100, render: (value: string | null) => invoiceStatusLabel(value) }
          ]}
        />
      </Card>

      <Card size="small" title="付款" style={{ marginTop: 12 }}>
        <Table<PaymentRow>
          rowKey="id"
          size="small"
          pagination={false}
          dataSource={payments ?? []}
          loading={paymentsLoading}
          locale={{ emptyText: '暂无付款记录' }}
          columns={[
            { title: '付款单号', dataIndex: 'payNo', width: 180 },
            { title: '金额', dataIndex: 'payAmount', width: 130, align: 'right', render: (value: number) => formatAmount(value) },
            { title: '方式', dataIndex: 'payMethod', width: 100, render: (value: string | null) => payMethodLabel(value) },
            { title: '付款时间', dataIndex: 'payAt', width: 160, render: (value: string | null) => formatDisplayTime(value) },
            { title: '凭证号', dataIndex: 'voucherNo', width: 140, render: (value: string | null) => value || '-' }
          ]}
        />
      </Card>
    </>
  );
}
